import * as React from 'react';
import { IconButton, Typography } from '@mui/material';
import { MoreHoriz, WarningOutlined } from '@mui/icons-material';

import { Popup } from 'components';
import { IEmployee } from 'models';

export const formatPhoneNumber = (value: string) => {
  if (!value) return value;

  // remove non-numeric values and take the last 10 digits
  const phoneNumber = value.replace(/\D/g, '').slice(-10);

  if (phoneNumber.length < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

export const createEmployeesTableData = (isAdmin: boolean) => (employee: IEmployee) => {
  const { activateEmployee, deactivateEmployee, editEmployee, userBuildingAssignments } = employee;

  const options = [
    {
      id: 1,
      label: 'Edit User',
      onClick: () => {
        editEmployee(employee);
      },
    },
  ];

  if (isAdmin) {
    options.unshift({
      id: 2,
      label: 'Building Assignments',
      onClick: () => {
        userBuildingAssignments(employee);
      },
    });
  }

  if (employee.code !== null) {
    options.unshift({
      id: 3,
      label: 'Deactivate User',
      onClick: () => {
        deactivateEmployee(employee);
      },
    });
  }

  if (employee.code === null) {
    options.unshift({
      id: 4,
      label: 'Activate User',
      onClick: () => {
        activateEmployee(employee);
      },
    });
  }

  return {
    id: (
      <Typography variant="body2" color={employee.code ? 'textPrimary' : 'textSecondary'}>
        {employee.id}
      </Typography>
    ),
    name: (
      <Typography variant="body2" color={employee.code ? 'textPrimary' : 'textSecondary'}>
        {employee.name}
      </Typography>
    ),
    code: (
      <Typography variant="body2" color={employee.code ? 'textPrimary' : 'textSecondary'}>
        {employee.code}
      </Typography>
    ),
    email: (
      <Typography variant="body2" color={employee.code ? 'textPrimary' : 'textSecondary'}>
        {employee.email}
      </Typography>
    ),
    phone: (
      <Typography
        variant="body2"
        color={employee.code ? 'textPrimary' : 'textSecondary'}
        sx={{ display: 'flex', alignContent: 'center' }}
      >
        {employee.phone_verified_at === null && <WarningOutlined fontSize={'small'} color={'primary'} />}
        {formatPhoneNumber(employee.phone)}
      </Typography>
    ),
    actions: (
      <Popup items={options} width={210}>
        <IconButton color="primary" size="small">
          <MoreHoriz />
        </IconButton>
      </Popup>
    ),
  };
};

export const convertEmployeesToTableData = (isAdmin: boolean) => (employees: Array<IEmployee>) => {
  return employees.map((employee) => createEmployeesTableData(isAdmin)(employee));
};
